import type { FC } from 'react';

import type { PendingChange } from '@eluve/api-contract';
import { Stack, Text } from '@eluve/components';

/** The struck-old → violet-new span every change diff renders: old value
 *  struck through, proposed value in violet. The proposed only goes live on
 *  confirm. */
export const InlineChangeDiff: FC<{
  previous: string | null;
  proposed: string | null;
}> = ({ previous, proposed }) => (
  <span>
    <Text inline size="sm" className="text-text-secondary line-through">
      {previous ?? '—'}
    </Text>
    <Text inline size="sm" className="text-text-insights">
      {' → '}
    </Text>
    <Text inline size="sm" weight="medium" className="text-text-insights">
      {proposed ?? '—'}
    </Text>
  </span>
);

/**
 * The purple diff for an AI-proposed change to an existing plan item. Dates
 * render inline (old → new); text stacks (the old line above the proposed)
 * since it's longer.
 */
export const PendingChangeDiff: FC<{ change: PendingChange }> = ({
  change,
}) => {
  const inline = change.field === 'targetDate' || change.field === 'status';

  if (inline) {
    return (
      <div className="mt-1.5">
        <InlineChangeDiff
          previous={change.previous}
          proposed={change.proposed}
        />
      </div>
    );
  }

  return (
    <Stack direction="vertical" gap={0.5} className="mt-1.5">
      <Text size="sm" className="text-text-secondary line-through">
        {change.previous ?? '—'}
      </Text>
      <Text size="sm" weight="medium" className="text-text-insights">
        {change.proposed ?? '—'}
      </Text>
    </Stack>
  );
};
